import axios from 'axios';
import { API_Link, ValidateHeader } from "../common/Constants";

/**
 * Background API Service
 * Handles ES and AFP results update independently
 * Does not block login or any other operations
 */

export const triggerBackgroundApis = (token) => {
  // Use requestIdleCallback if available (modern browsers)
  // Falls back to setTimeout for older browsers
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(() => {
      executeBackgroundApis(token);
    });
  } else {
    // Fallback for older browsers
    setTimeout(() => {
      executeBackgroundApis(token);
    }, 100);
  }
};

const executeBackgroundApis = async (token) => {
  try {

    // Execute both APIs in parallel
    const [esResult, afpResult] = await Promise.allSettled([
      axios.post(
        `${API_Link}storeEsResults`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'plims-auth': ValidateHeader,
            Authorization: `Bearer ${token}`,
          },
          timeout: 0, // 0 time limit
        }
      ),
      axios.post(
        `${API_Link}storeAfpResults`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'plims-auth': ValidateHeader,
            Authorization: `Bearer ${token}`,
          },
          timeout: 0, // 0 time limit
        }
      ),
    ]);

   
  } catch (error) {
    // Silent fail - doesn't affect user login
  }
};